<template>
  <el-dialog
    title="调整库存"
    :visible.sync="visible"
    width="320px"
    :close-on-press-escape="false"
    @closed="handleClose">
    <el-form
      ref="ruleForm"
      status-icon
      :model="info"
      :rules="rules"
      label-width="90px"
      @submit.native.prevent>
      <el-form-item
        key="couponName"
        label="优惠劵名称:"
        prop="couponName">
        {{ info.couponName }}
      </el-form-item>
      <el-form-item
        key="increase"
        label="库存:"
        prop="increase">
        <el-input-number
          v-model="info.increase"
          :min="min"
          :precision="0"></el-input-number>
        <el-tooltip
          :content="`负数为减少库存（最小为${min}），正数为增加库存`"
          placement="top">
          <i
            class="el-icon-warning-outline"
            style="margin-left:5px"></i>
        </el-tooltip>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">提 交</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'EntRegisterModal',
  components: { },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      visible: false,
      info: {
        vendorId: null,
        couponName: null,
        couponId: null,
        increase: undefined
      },
      min: 0,
      rules: {
        increase: [
          { required: true, message: '请输入库存', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    update(row) {
      this.info.vendorId = row.vendorId
      this.info.couponId = row.couponId
      this.info.couponName = row.couponName
      this.min = -row.remainCount
      this.toggleModal(true)
    },
    toggleModal(visible) {
      this.visible = visible
    },
    handleClose() {
      this.info = {
        vendorId: null,
        couponName: null,
        couponId: null,
        increase: undefined
      }
      this.min = 0
      this.$refs.ruleForm.resetFields()
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(`coupon/increasecouponcount`, {
            payload: {
              ...this.info
            },
            success: () => {
              this.loading = false
              this.callback && this.callback()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
